<template>
  <div class="section" id="profile-edit">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h1 class="subtitle">プロフィール</h1>

        <PhotoPreview v-model="photoFile" :currentSrc="photoURL" />
        <NicknameTextField v-model="nickname" />

        <b-field
          v-if="isPerformer"
          label="自己紹介"
          message="※100文字以内、改行は反映されます"
        >
          <b-input type="textarea" v-model="selfIntroduction" />
        </b-field>

        <b-field v-if="isPerformer" label="特技、配信ジャンル">
          <b-input
            type="array"
            v-model="category"
            placeholder="特技、配信ジャンル"
          ></b-input>
          <p class="control">
            <b-button class="button is-primary" @click="addToCategories"
              >追加</b-button
            >
          </p>
        </b-field>
        <b-taglist v-if="isPerformer" class="tags-display">
          <b-tag
            v-for="(category, index) in categories"
            :key="index"
            type="is-success"
            closable
            aria-close-label="Close tag"
            @close="remoteCategory(index)"
          >
            {{ category }}
          </b-tag>
        </b-taglist>

        <UserTypeRadio v-model="userType" />

        <b-field label="誕生日" v-if="birthDate">
          <b-input type="text" v-model="birthDate" disabled />
        </b-field>

        <div class="buttonwrap has-text-right">
          <b-button
            class="is-primary"
            @click="submitForm"
            :loading="submitting"
          >
            更新する
          </b-button>
        </div>

        <div class="buttonwrap has-text-centered">
          <b-button class="is-primary" @click="returnToMyPage"
            >マイページへ</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserTypeRadio from '@/components/Molecules/UserTypeRadio';
import NicknameTextField from '@/components/Molecules/NicknameTextField';
import PhotoPreview from '@/components/Molecules/PhotoPreview';
import moment from 'moment';

export default {
  name: 'Profile',
  components: {
    UserTypeRadio,
    NicknameTextField,
    PhotoPreview
  },
  data() {
    return {
      photoFile: null,
      photoURL: '',
      nickname: '',
      selfIntroduction: '',
      categories: [],
      category: '',
      userType: '',
      submitting: false
    };
  },
  async created() {
    try {
      await this.$store.dispatch(
        'user/loadUserDoc',
        this.$store.state.auth.uid
      );
      console.log(this.$store.state.user);
      this.photoURL =
        this.$store.state.user.photoURL == ''
          ? 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50'
          : this.$store.state.user.photoURL;
      this.nickname = this.$store.state.user.nickname;
      this.selfIntroduction = this.$store.state.user.selfIntroduction;
      this.categories = this.$store.state.user.categories;
      this.userType = this.$store.state.user.userType;
    } catch (err) {
      console.error(err);
      return;
    }
  },
  computed: {
    birthDate() {
      return moment
        .unix(this.$store.state.user.birthDate.seconds)
        .format('YYYY/MM/DD');
    },
    isPerformer() {
      return this.userType === 'performer';
    }
  },
  methods: {
    returnToMyPage() {
      // this.$router.push('/mypage');
    },
    addToCategories() {
      if (this.category == '') return;
      // TODO: no action if category is duplicated
      this.categories.push(this.category);
      this.category = '';
    },
    remoteCategory(index) {
      this.categories.splice(index, 1);
    },
    async submitForm() {
      this.submitting = true;
      try {
        await this.$store.dispatch('updateUserProfile', {
          nickname: this.nickname,
          photoFile: this.photoFile,
          userType: this.userType,
          categories: this.categories,
          selfIntroduction: this.selfIntroduction
        });
        this.$buefy.toast.open({
          message: 'プロフィールがアップデートされました',
          type: 'is-success'
        });
      } catch (err) {
        console.error(err);
        this.$buefy.toast.open({
          message: 'プロフィールのアップデートが失敗しました',
          type: 'is-danger'
        });
      }
      this.submitting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/profile-edit.scss';

.floatable-preview {
  position: relative;
}

.floating-camera-icon {
  position: absolute;
  background-color: rgba(256, 256, 256, 0.75);
  border-radius: 50%;
  bottom: 8%;
  right: 8%;
  padding: 8%;
}
.floating-camera-icon:hover {
  cursor: pointer;
}
.field.has-addons .control:not(:last-child) {
  width: 100%;
}
.tags-display {
  margin-bottom: 10px;
}
</style>
